//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { GetEssentialServicesResponse } from './models/GetEssentialServicesResponse';
import type { GetRecommendedServicesResponse } from './models/GetRecommendedServicesResponse';
import type { ServiceResponse } from './models/ServiceResponse';
import { Utilities } from './Utilities';

export class ServicesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getServices: (
			platform?: string,
			language?: string,
			accessType?: string,
			additionalServices?: string,
			enrichServiceInfo?: boolean,
			searchTerm?: string,
        ): string => {
            let clientRequestUrl = '/api/v3/services?';
            if (platform === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('platform'));
            } else if (platform !== undefined) {
                clientRequestUrl += `platform=${encodeURIComponent(String(platform))}&`;
            }
            if (language === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('language'));
            } else if (language !== undefined) {
                clientRequestUrl += `language=${encodeURIComponent(String(language))}&`;
            }
            if (accessType === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('accessType'));
            } else if (accessType !== undefined) {
                clientRequestUrl += `accessType=${encodeURIComponent(String(accessType))}&`;
            }
            if (additionalServices === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('additionalServices'));
            } else if (additionalServices !== undefined) {
                clientRequestUrl += `additionalServices=${encodeURIComponent(String(additionalServices))}&`;
            }
            if (enrichServiceInfo === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('enrichServiceInfo'));
            } else if (enrichServiceInfo !== undefined) {
                clientRequestUrl += `enrichServiceInfo=${encodeURIComponent(String(enrichServiceInfo))}&`;
            }
            if (searchTerm === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('searchTerm'));
            } else if (searchTerm !== undefined) {
                clientRequestUrl += `searchTerm=${encodeURIComponent(String(searchTerm))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getRecommendedServices: (
			platform?: string,
			language?: string,
        ): string => {
            let clientRequestUrl = '/api/v3/services/recommended?';
            if (platform === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('platform'));
            } else if (platform !== undefined) {
                clientRequestUrl += `platform=${encodeURIComponent(String(platform))}&`;
            }
            if (language === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('language'));
            } else if (language !== undefined) {
                clientRequestUrl += `language=${encodeURIComponent(String(language))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getEssentialServices: (
			language?: string,
        ): string => {
            let clientRequestUrl = '/api/v3/services/essentials?';
            if (language === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('language'));
            } else if (language !== undefined) {
                clientRequestUrl += `language=${encodeURIComponent(String(language))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getServicesLanguage: (
			language: string,
        ): string => {
            let clientRequestUrl = '/api/v3/services/translate/{language}';
            if (language === undefined || language === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('language'));
            }
            clientRequestUrl = clientRequestUrl.replace('{language}', encodeURIComponent(String(language)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all services available to the user.
     * @param platform (optional) Can be DesktopBrowser, MobileBrowser, IosApp or AndroidApp.
     * @param language (optional) Lang of Content. Default: en
     * @param accessType (optional) Indicate user access to services. Can be HasAccess, NoAccess, Both, HasAccessWithoutHiddenConsideration, BothForCatalog or All.
     * @param additionalServices (optional) Comma-separated list of additional sets of services to include.
    Supported values: nonSgmServices
     * @param enrichServiceInfo (optional) Add information about bookmark, ranking and visibility.
     * @param searchTerm (optional) Term used to search for services.
     * @return OK
     */
    async getServices(
        platform?: string,
        language?: string,
        accessType?: string,
        additionalServices?: string,
        enrichServiceInfo?: boolean,
        searchTerm?: string,
    ): Promise<ServiceResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getServices(
            platform,
            language,
            accessType,
            additionalServices,
            enrichServiceInfo,
            searchTerm,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ServiceResponse>(_response, false, []);
    }

    /**
     * Retrieves recommended services for the user.
     * @param platform (optional) The platform for which recommendations are requested.
     * @param language (optional) The language of the content. Defaults to "en".
     * @return OK
     */
    async getRecommendedServices(
        platform?: string,
        language?: string,
    ): Promise<GetRecommendedServicesResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getRecommendedServices(
            platform,
            language,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetRecommendedServicesResponse>(_response, false, []);
    }

    /**
     * Retrieves essential services for the user.
     * @param language (optional) The language of the content. Defaults to "en".
     * @return OK
     */
    async getEssentialServices(
        language?: string,
    ): Promise<GetEssentialServicesResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getEssentialServices(
            language,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetEssentialServicesResponse>(_response, false, []);
    }

    /**
     * Retrieves translated content for service keys.
     * @param language The language code (e.g., "en", "fr").
     * @return OK
     */
    async getServicesLanguage(
        language: string,
    ): Promise<{ [key: string]: string; }> {
        const clientRequestUrl = this.baseUrl + this.routes.getServicesLanguage(
            language,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<{ [key: string]: string; }>(_response, false, [/* { [key: string]: string; } */]);
    }
}
